import { render, staticRenderFns } from "./TableConfig.vue?vue&type=template&id=fe5b619c&scoped=true"
import script from "./TableConfig.vue?vue&type=script&lang=js"
export * from "./TableConfig.vue?vue&type=script&lang=js"
import style0 from "./TableConfig.vue?vue&type=style&index=0&id=fe5b619c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5b619c",
  null
  
)

export default component.exports